const campaignActionTypes = {
    // types for mutations
    VARIABLES: 'VARIABLES',
    MONITORING_VARIABLES: 'MONITORING_VARIABLES',
    CALL_LOG_ACTIVATED: 'CALL_LOG_ACTIVATED',
    NODE_LIST: 'NODE_LIST',
    NODES_SUCCESS: 'NODES_SUCCESS',
    DEBUG_NODE_ACTIVATED: 'DEBUG_NODE_ACTIVATED',
    TREE_DATA: 'TREE_DATA',
    FS_LOG: 'FS_LOG',
    CALL_MONITOR: 'CALL_MONITOR',
    IS_DATA_FLOW_ERROR: 'IS_DATA_FLOW_ERROR',

    // types for actions
    RESET_ACTIVATED: 'RESET_ACTIVATED',
    UPDATE_DATA_FLOW: 'UPDATE_DATA_FLOW',
    ADD_MONITORING_VARS: 'ADD_MONITORING_VARS',
    DELETE_MONITORING_VAR: 'DELETE_MONITORING_VAR',
    NOTICE_DATA_FLOW_ERROR: 'NOTICE_DATA_FLOW_ERROR',
}

export default campaignActionTypes
